import getUserLocaleBase from 'get-user-locale';

import { getLocale } from '~/constants/Locale';

const getUserLocale = (): ReturnType<typeof getLocale> => {
    const rawLocale = getUserLocaleBase();
    return getLocale(rawLocale);
};

export default getUserLocale;
